import { SERVER_URL } from '../constants/config'

export const getEndpoint = url => `${SERVER_URL}/api/v1/${url}`
